import { ICreateModifierContext } from './createModifierContext';

export enum CreateModifierActionTypes {
	SET_FILE_ID = 'SET_FILE_ID',
	SET_FETCHED_CUSTOMERS = 'SET_FETCHED_CUSTOMERS',
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	SET_FETCHED_RESTAURANTS = 'SET_FETCHED_RESTAURANTS',
	SET_IDS_RESTAURANT = 'SET_IDS_RESTAURANT',
	CHANGE_NAME_OF_MODIFIER = 'CHANGE_NAME_OF_MODIFIER',
	CHANGE_DESCRIPTION = 'CHANGE_DESCRIPTION',
	CHANGE_EXTERNAL_ID = 'CHANGE_EXTERNAL_ID',
	TOGGLE_HAS_SCHEDULE_PRIORITY = 'TOGGLE_HAS_SCHEDULE_PRIORITY',
	CHANGE_ACTIVATION_SCHEDULE = 'CHANGE_ACTIVATION_SCHEDULE',
	CHANGE_DEACTIVATION_SCHEDULE = 'CHANGE_DEACTIVATION_SCHEDULE',
	SET_FETCHED_TRANSLATIONS = 'SET_FETCHED_TRANSLATIONS',
	SET_TRANSLATION_TAB = 'SET_TRANSLATION_TAB',
	CHANGE_TRANSLATION = 'CHANGE_TRANSLATION',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface ISetFileId {
	type: CreateModifierActionTypes.SET_FILE_ID;
	payload: {
		fileId: ICreateModifierContext['fileId'];
	};
}

interface ISetFetchedCustomers {
	type: CreateModifierActionTypes.SET_FETCHED_CUSTOMERS;
	payload: {
		fetchedCustomers: ICreateModifierContext['fetchedCustomers'];
	};
}

interface ISetIDCustomer {
	type: CreateModifierActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: ICreateModifierContext['IDSelectedCustomer'];
	};
}

interface ISetFetchedRestaurants {
	type: CreateModifierActionTypes.SET_FETCHED_RESTAURANTS;
	payload: {
		fetchedRestaurants: ICreateModifierContext['fetchedRestaurants'];
	};
}

interface ISetIDsRestaurant {
	type: CreateModifierActionTypes.SET_IDS_RESTAURANT;
	payload: {
		IDsSelectedRestaurant: ICreateModifierContext['IDsSelectedRestaurant'];
	};
}

interface IChangeNameOfModifier {
	type: CreateModifierActionTypes.CHANGE_NAME_OF_MODIFIER;
	payload: {
		nameOfModifier: ICreateModifierContext['nameOfModifier'];
	};
}

interface IChangeDescription {
	type: CreateModifierActionTypes.CHANGE_DESCRIPTION;
	payload: {
		description: ICreateModifierContext['description'];
	};
}

interface IChangeExternalId {
	type: CreateModifierActionTypes.CHANGE_EXTERNAL_ID;
	payload: {
		externalId: ICreateModifierContext['externalId'];
	};
}

interface IToggleHasSchedulePriority {
	type: CreateModifierActionTypes.TOGGLE_HAS_SCHEDULE_PRIORITY;
}

interface IChangeActivationSchedule {
	type: CreateModifierActionTypes.CHANGE_ACTIVATION_SCHEDULE;
	payload: {
		activationSchedule: ICreateModifierContext['activationSchedule'];
	};
}

interface IChangeDeactivationSchedule {
	type: CreateModifierActionTypes.CHANGE_DEACTIVATION_SCHEDULE;
	payload: {
		deactivationSchedule: ICreateModifierContext['deactivationSchedule'];
	};
}

interface ISetFetchedTranslation {
	type: CreateModifierActionTypes.SET_FETCHED_TRANSLATIONS;
	payload: {
		translations: ICreateModifierContext['translations'];
		defaultCustomerLanguage: ICreateModifierContext['defaultCustomerLanguage'];
	};
}

interface ISetTranslationTab {
	type: CreateModifierActionTypes.SET_TRANSLATION_TAB;
	payload: {
		selectedTranslationTab: ICreateModifierContext['selectedTranslationTab'];
	};
}

interface IChangeTranslation {
	type: CreateModifierActionTypes.CHANGE_TRANSLATION;
	payload: {
		translations: ICreateModifierContext['translations'];
	};
}

interface ISetDataForSubmit {
	type: CreateModifierActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: ICreateModifierContext['dataForSubmit'];
	};
}

interface IChangeTypeOfModalWindow {
	type: CreateModifierActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: ICreateModifierContext['typeOfModalWindow'];
	};
}

interface IResetSelectedControls {
	type: CreateModifierActionTypes.RESET_FIELDS;
}

export type TCreateModifierAction =
	| ISetFileId
	| ISetFetchedCustomers
	| ISetIDCustomer
	| ISetFetchedRestaurants
	| ISetIDsRestaurant
	| IChangeNameOfModifier
	| IChangeDescription
	| IChangeExternalId
	| IToggleHasSchedulePriority
	| IChangeActivationSchedule
	| IChangeDeactivationSchedule
	| ISetFetchedTranslation
	| ISetTranslationTab
	| IChangeTranslation
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow
	| IResetSelectedControls;
